const memoryValues = new Map();

// Only keys deliberately approved for persistence on this computer belong here.
const ALLOWED_KEYS = new Set([
  "cls_admin_billing_drafts_v1",
  "cls_pms_lab_workspace_v1",
  // LACW preview test mode only: the demo's made-up diary week, file requests and the
  // walkthrough's step (src/lib/remindersDemo.js). Never real client data.
  "cls_lacw_aid_diary_active_v1",
  "cls_lacw_local_test_file_requests_v1",
  "cls_lacw_local_test_walkthrough_v1",
]);

function assertAllowedKey(key) {
  if (!ALLOWED_KEYS.has(key)) {
    throw new Error(`Device storage key is not allowed: ${key}`);
  }
}

function localStorageOrNull() {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

// window.localStorage is the wrapper from src/main.jsx, which answers reads from a copy taken
// when the tab loaded and swallows failed writes. Billing weeks are saved by rewriting the
// whole list, so a tab left open used to read its old list and write it back, deleting weeks
// saved from another tab; and a full browser reported a save that never happened. These keys
// go straight to the browser's own storage, so reads are current and a failed write throws.
function nativeOf(storage) {
  return storage?.__native || null;
}

export const deviceStorage = {
  getItem(key) {
    assertAllowedKey(key);
    const storage = localStorageOrNull();
    if (storage) return (nativeOf(storage) || storage).getItem(key);
    return memoryValues.has(key) ? memoryValues.get(key) : null;
  },
  setItem(key, value) {
    assertAllowedKey(key);
    const storage = localStorageOrNull();
    if (storage) {
      nativeOf(storage)?.setItem(key, String(value));
      storage.setItem(key, String(value));
      return;
    }
    memoryValues.set(key, String(value));
  },
  removeItem(key) {
    assertAllowedKey(key);
    const storage = localStorageOrNull();
    if (storage) storage.removeItem(key);
    memoryValues.delete(key);
  },
};
